import VolcRTC, { AudioSourceType, StreamIndex, VideoSourceType } from '@volcengine/rtc';

/**
 * 火山 RTC SDK 只在火山实时业务的依赖图中静态打包，避免进入通话后再等待额外 chunk。
 * 单独的模块边界也让 RTC 会话测试可以替换 SDK，避免 jsdom 执行浏览器初始化副作用。
 */
/**
 * 与此前的 `import('@volcengine/rtc')` 保持相同的 module namespace 形状。
 * SDK 默认导出承载 engine API，枚举则是 named exports；不能直接把 default 对象
 * 强转为 module，否则消费者读取 `sdk.default` 时会得到 undefined。
 */
export const getVolcRtcSdk = () => ({
  AudioSourceType,
  StreamIndex,
  VideoSourceType,
  default: VolcRTC,
});
